/*
 * Created Date: 08-09-2022, 9:01:02 pm
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { Icon, InputAdornment } from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import CoreInput from './CoreInput'
import { Search } from '@mui/icons-material'

const CoreInputSearch = props => {
	const { className, control, name, placeholder, ...restProps } = props
	const { t } = useTranslation('common')
	return (
		<CoreInput
			control={control}
			className={clsx('w-160', className)}
			name={name}
			// label={t('search')}
			placeholder={placeholder ?? t('placeholder.search')}
			{...restProps}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<Search />
					</InputAdornment>
				)
			}}
		/>
	)
}

CoreInputSearch.defaultProps = {
	name: 'search',
	size: 'small'
}

CoreInputSearch.propTypes = {
	...CoreInput.type.propTypes
}

export default React.memo(CoreInputSearch)
